<!--
     <CentroLogo
       :centro_id="centro_id"
       style='width: 48px; height: 48px'
     />
-->

<template>
  <img
    class="cl-logo"
    :src="centro_logo"
    @error="failed = true"
  />
</template>


<style lang="scss">
 .cl-logo {
   height: 100%;
   width: 100%;
   object-fit: contain;
 }
</style>


<script>
 import { mapState, mapGetters } from 'vuex'
 import { resolve_logo } from '@/utils/logos';

 const FALLBACK_LOGO = require('@/assets/image_not_found.png');

 export default {
   name: 'CentroLogo',

   components: {
   },
   
   props: [
     'centro_id'
   ],

   data: () => ({
     failed: false,
   }),

   computed: {
     ...mapState(['centros']),
     ...mapGetters({
       default_centro_id: 'centro_id',
     }),

     centro() {
       const cid = this.centro_id || this.default_centro_id;
       return this.centros[cid];
     },

     centro_logo() {
       return resolve_logo(this.centro.logo, this.failed);
     },
   },

   methods: {
   },

   watch: {
     centro_id(val) {
       this.failed = false;
     },
   }
 };
</script>
